import MobileCards from './MobileCards';
import RevealCards from './ui/cards-grid';

const CategoriesSection = () => {
    return (
        <div>
            <div className="hidden lg:block"> {/* visible uniquement sur grand écran (≥1024px) */}
                <RevealCards />
            </div>
            <div className="block md:block lg:hidden"> {/* visible sur mobile et tablette (<1024px) */}
                <MobileCards />
            </div>
        </div>
    );
};

export default CategoriesSection;